import { render, staticRenderFns } from "./ZaloListAllUser.vue?vue&type=template&id=0bf076f5&scoped=true"
import script from "./ZaloListAllUser.vue?vue&type=script&lang=js"
export * from "./ZaloListAllUser.vue?vue&type=script&lang=js"
import style0 from "./ZaloListAllUser.vue?vue&type=style&index=0&id=0bf076f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf076f5",
  null
  
)

export default component.exports